<template>
  <div>
    <page-title :heading=heading :subheading=subheading icon='fas fa-wallet fa-fw icon-color'></page-title>
    <v-container>
      <v-layout class="mb-2" row wrap>
        <v-spacer></v-spacer>
        <div style="width: 35%">
          <v-text-field v-model="representativesSearch" :label="$t('general.search')" clearable prepend-inner-icon="search"></v-text-field>
        </div>
        <v-btn class="mt-3 mx-3" color="primary" round dark @click="downloadReport" :disabled="loadingExcelReport">
          <v-icon left>download</v-icon>
          {{ $t('general.downloadReport') }}
        </v-btn>
      </v-layout>
      <v-data-table
        :search="representativesSearch"
        class="elevation-2"
        :headers="headers"
        :items="representatives"
        :loading="loadingItems"
        :rows-per-page-items="[10,15,25]"
        :pagination.sync="pagination"
      >
        <template v-slot:headers="props">
          <tr class="bg-heavy-rain">
            <th v-for="header in props.headers"
                :key="header.text"
                :class="['font-weight-black white--text column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']">
              <h2 class="font-weight-black primary--text mb-0">
                <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                {{header.text}}
              </h2>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr>
            <td class="text-sm-center">{{props.item.representative.name}}</td>
            <td class="text-sm-center">{{props.item.user && props.item.user.name}}</td>
            <td class="text-sm-center">{{props.item.area !== null ? props.item.area.name : null}}</td>
            <td class="text-sm-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn @click="removed(props.item)" small outline icon color="error" v-on="on">
                    <v-icon small>delete</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('general.delete')  }}</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>

      <v-dialog persistent v-model="removeDialog" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="error--text font-weight-bold mb-0">{{ $t('representatives.delete') }}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('general.deleteElementQuestion') }}</p>
            <p class="font-weight-black">
              <span class="error--text"> {{ $t('user.name')}}: </span> {{ removedItem.representative.name }}
              <span class="error--text"> {{ $t('representatives.representative')}}: </span>
              {{ removedItem.user.name }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="closeDelete" color="error darken-1" round flat>
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn @click="deleteItem(removedItem)" :disabled="loading" :loading="loading" color="error" round depressed>
              {{ $t('general.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'representativesComponent',
  data () {
    return {
      representativesSearch: '',
      removeDialog: false,
      loading: false,
      loadingItems: true,
      dialog: false,
      users: [],
      areas: [],
      representatives: [],
      errors: {},
      editedItem: {
        user_id: null,
        area_id: null
      },
      defaultItem: {
        user_id: null,
        area_id: null
      },
      pagination: {
        descending: false,
        page: 0,
        rowsPerPage: 15, // -1 for All",
        totalItems: 0
      },
      removedItem: {
        user: { name: '' },
        area: { name: '' },
        representative:{ name: '' }
      },
      loadingExcelReport: false
    }
  },
  computed: {
    heading () {
      return this.$t('representatives.title')
    },
    subheading () { 
      return this.$t('representatives.subtitle') 
    },
    headers () {
      return [
        {
          text: this.$t('user.name'),
          align: 'center',
          value: 'user.name',
          sortable: false
        },
        {
          text: this.$t('representatives.representative'),
          align: 'center',
          value: 'user.name',
          sortable: false
        },
        {
          text: this.$t('area.name'),
          align: 'center',
          value: 'area.name',
          sortable: false
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
    }
  },
  watch: { },
  created () {
    this.getRepresentatives()
  },
  methods: {
    getRepresentatives () {
      this.$emit('representativesGet', {context: this})
    },
    downloadReport() {
      this.loadingExcelReport = true
      this.$emit('downloadReport', { context: this })
    },
    removed (item) {
      this.removedItem = item
      this.removeDialog = true
    },
    deleteItem (item) {
      this.loading = true
      const index = this.representatives.indexOf(item)
      this.delete(item, index)
    },
    delete (item, index) {
      this.$emit('representativesDelete', {
        item: item,
        index: index,
        context: this
      })
    },
    close () {
      this.editedItem = Object.assign({}, this.defaultItem)
      this.$refs.form.resetValidation()
      this.loading = false
      this.dialog = false
      this.errors = {}
    },
    closeDelete () {
      this.removeDialog = false
      this.loading = false
    },
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/representatives.component.vue